import { dispatcher, api } from '@unicus/react-ui-kit';

export const NOTIFICATION = 'NOTIFICATION';
export const NOTIFICATION_SET_VISUALIZED = 'NOTIFICATION_SET_VISUALIZED';
export const NOTIFICATION_SET_VISUALIZED_FINISHED =
  'NOTIFICATION_SET_VISUALIZED_FINISHED';

export const setVisualized = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'notifications',
    actionType: NOTIFICATION_SET_VISUALIZED,
    effect: async () => api.post(`notifications/visualized/${id}`),
    onSuccess
  });
};
